import { render, staticRenderFns } from "./GChatLabel.vue?vue&type=template&id=729026ef&"
import script from "./GChatLabel.vue?vue&type=script&lang=ts&"
export * from "./GChatLabel.vue?vue&type=script&lang=ts&"
import style0 from "./GChatLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports